const translations = {
    close: 'Close',
    draw: 'Draw'
};

export default translations;
